import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  errorMessageText: {
    color: '#f7041c',
    textAlign: 'center',
    padding: 0,
    margin: 0
  }
})

export default useStyles